import React from 'react';
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';
import '../styles/ServicePlan.css';


const ServicePlan = ({ serviceId,serviceName,serviceDescription}) => {

  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleClick = () => {
    
   
   
  // navigate(`/services`, { state: { serviceId} });
   navigate(`/services`, {
    state: { serviceId, serviceName }
  });

  };

  return (
    <div 
      className="mb-4 border border-primary rounded p-3"
      style={{ backgroundColor: '#fff', boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)' }}
      onClick={handleClick}
    >

      
<h2 className="h5">{serviceName}</h2>

      <p className="text-secondary">{serviceDescription}</p>

      <div style={{ borderBottom: '1px solid #ddd', marginBottom: '1rem' }}></div>

      <a 
        href="#"
        className="text-primary"
        style={{ display: 'flex', alignItems: 'center', textDecoration: 'none', color: "#004fbd" }}
        onClick={(e) => {
          e.preventDefault();
          handleClick();
        }}
      >
        {t("view_details")}
        <div 
          className="ms-2 p-2 rounded-circle"
          style={{ 
            border: '2px solid #5DC486', 
            color: '#5DC486', 
            width: '20px', 
            height: '20px', 
            display: 'flex', 
            justifyContent: 'center', 
            alignItems: 'center' 
          }}
        >
          <FontAwesomeIcon icon={faChevronRight} />
        </div>
      </a>
    </div>
  );
};

export default ServicePlan;
